import { twJoin } from 'tailwind-merge'

export const CONTENT_HORIZONTAL_PADDING_CLASSNAME = 'px-4 tablet:px-6 desktop:px-14'

export const CONTENT_CLASSNAME = twJoin(
  CONTENT_HORIZONTAL_PADDING_CLASSNAME,
  'mx-auto w-full max-w-400',
)

export const DASHBOARD_LAYOUT_CLASSNAME =
  'bg-bg-page text-base text-text-primary relative font-normal relative font-inter'
